import React from 'react';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const Logo = ({ className = '', width = 50, height = 50 }: LogoProps) => {
  return (
    <img
      src="/images/logo.png"
      alt="Elev8 Growth Solutions"
      width={width}
      height={height}
      className={className}
      loading="eager"
      decoding="async"
    />
  );
};

export default Logo;
